import { theme, extendTheme } from "@chakra-ui/react"

export default extendTheme({
  colors: {
    grass: theme.colors.green[300],
    fire: theme.colors.red[300],
    water: theme.colors.blue[300],
    bug: theme.colors.teal[300],
    electric: theme.colors.yellow[300],
    poison: theme.colors.purple[300],
    flying: theme.colors.telegram[300],
    ice: theme.colors.cyan[300],
    psychic: theme.colors.pink[300],
    fighting: theme.colors.orange[300],
    rock: theme.colors.orange[500],
    fairy: theme.colors.pink[200],
    ground: theme.colors.yellow[200],
    ghost: theme.colors.blue[200],
    dragon: theme.colors.purple[200],
    dark: theme.colors.orange[600],
    steel: theme.colors.gray[300],
    normal: theme.colors.gray[400],
  },
})
